import * as ActionTypes from "./actionTypes";
import * as Actions from "./action";
import { ServiceContract } from "src/common/models/contract";
import { ServiceContractError, ServiceContractErrorOrigin } from "./types";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { parseDataKey } from "src/common/util";
import { ServiceDebitContract } from "src/common/models/serviceContractDebit";

export interface ServiceContractState {
    currentContract?: Partial<ServiceContract>
    error?: ServiceContractError | undefined
    createServiceContractSuccess: boolean
    serviceContracts?: ServiceContract[]
    serviceContractDebits?: ServiceDebitContract[]
    currentContractDebit?: ServiceDebitContract
    updateServiceContractSuccess: boolean
    deleteServiceContractDebitSuccess: boolean
}

const initialState: ServiceContractState = {
    createServiceContractSuccess: false,
    updateServiceContractSuccess: false,
    deleteServiceContractDebitSuccess: false,
}

const serviceContractReducer = (state: ServiceContractState = initialState, action: any): ServiceContractState => {
    switch (action.type) {
        case ActionTypes.UPDATE_CURRENT_CONTRACT: {
            const updateAction = action as Actions.UpdateContractAction

            return {
                ...state,
                currentContract: {
                    ...state.currentContract,
                    ...updateAction.contractFields,
                },
            }
        }
        case ActionTypes.CLEAN_CURRENT_CONTRACT: {
            return {
                ...state,
                currentContract: undefined,
                createServiceContractSuccess: false,
                updateServiceContractSuccess: false,
            }
        }
        case ActionTypes.CREATE_SERVICE_CONTRACT_API: {
            return {
                ...state,
                error: undefined,
            }
        }
        case ActionTypes.CREATE_SERVICE_CONTRACT_API_SUCCESS: {
            return {
                ...state,
                createServiceContractSuccess: true,
            }
        }
        case ActionTypes.CREATE_SERVICE_CONTRACT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.CREATE_SERVICE_CONTRACT,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_SERVICE_CONTRACTS_API: {
            return {
                ...state,
                serviceContracts: undefined,
            }
        }
        case ActionTypes.GET_SERVICE_CONTRACTS_API_SUCCESS: {
            const successAction = action as Actions.GetServiceContractsSuccessAction

            return {
                ...state,
                serviceContracts: parseDataKey(successAction.serviceContracts),
            }
        }
        case ActionTypes.GET_SERVICE_CONTRACTS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.GET_SERVICE_CONTRACTS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_CONTRACT_BY_ID_API: {
            return {
                ...state,
                currentContract: undefined,
            }
        }
        case ActionTypes.GET_CONTRACT_BY_ID_API_SUCCESS: {
            const successAction = action as Actions.GetServiceContractByIdSuccessAction

            const currentContract = successAction.serviceContract
            currentContract.payDate = currentContract.paymentDay || undefined

            return {
                ...state,
                currentContract: successAction.serviceContract,
            }
        }
        case ActionTypes.GET_CONTRACT_BY_ID_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.GET_CONTRACT_BY_ID,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_SERVICE_CONTRACT_DEBITS_API: {
            return {
                ...state,
                serviceContractDebits: undefined,
            }
        }
        case ActionTypes.GET_SERVICE_CONTRACT_DEBITS_API_SUCCESS: {
            const successAction = action as Actions.GetServiceContractDebitsSuccessAction

            return {
                ...state,
                serviceContractDebits: parseDataKey(successAction.serviceContractDebits),
            }
        }
        case ActionTypes.GET_SERVICE_CONTRACT_DEBITS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.GET_SERVICE_CONTRACCT_DEBITS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_CONTRACT_DEBIT_BY_ID_API: {
            return {
                ...state,
                currentContractDebit: undefined,
            }
        }
        case ActionTypes.GET_CONTRACT_DEBIT_BY_ID_API_SUCCESS: {
            const successAction = action as Actions.GetContractDebitByIdSuccessAction

            return {
                ...state,
                currentContractDebit: successAction.contractDebit,
            }
        }
        case ActionTypes.GET_CONTRACT_DEBIT_BY_ID_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.GET_CONTRACT_BY_ID,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.CLEAN_CURRENT_CONTRACT_DEBIT: {
            return {
                ...state,
                currentContractDebit: undefined,
            }
        }
        case ActionTypes.UPDATE_SERVICE_CONTRACT_API: {
            return {
                ...state,
                error: undefined,
                updateServiceContractSuccess: false,
            }
        }
        case ActionTypes.UPDATE_SERVICE_CONTRACT_API_SUCCESS: {
            return {
                ...state,
                updateServiceContractSuccess: true,
            }
        }
        case ActionTypes.UPDATE_SERVICE_CONTRACT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.UPDATE_SERVICE_CONTRACT,
                    detail: errorAction.error,
                },
            }
        }
        case ActionTypes.DELETE_SERVICE_CONTRACT_DEBIT_API: {
            return {
                ...state,
                deleteServiceContractDebitSuccess: false,
                error: undefined,
            }
        }
        case ActionTypes.DELETE_SERVICE_CONTRACT_DEBIT_API_SUCCESS: {
            return {
                ...state,
                deleteServiceContractDebitSuccess: true,
            }
        }
        case ActionTypes.DELETE_SERVICE_CONTRACT_DEBIT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceContractErrorOrigin.DELETE_SERVICE_CONTRACT_DEBIT,
                    detail: errorAction.error,
                }
            }
        }
    }
    return state;
};


export default serviceContractReducer;
